import { Dropdown, type DropdownOption } from './Dropdown';

export type PeriodOption<T extends string> = DropdownOption<T>;

/** Compact ghost-variant dropdown for time-period selectors on chart
 *  and table cards. Thin wrapper around <Dropdown> kept for backward
 *  compatibility with existing call sites — new code should use
 *  <Dropdown variant="ghost" size="sm"> directly. */
export function PeriodPicker<T extends string>({
  value,
  options,
  onChange,
  className,
}: {
  value: T;
  options: PeriodOption<T>[];
  onChange: (next: T) => void;
  className?: string;
}) {
  return (
    <Dropdown
      value={value}
      options={options}
      onChange={onChange}
      variant="ghost"
      size="sm"
      className={className}
    />
  );
}
